import { Spinner } from '@chakra-ui/react';
import React from 'react';

import useUserPassport from '@/hooks/useUserPassport';

const UserPassport = ({ children }: React.PropsWithChildren): React.JSX.Element => {
  const { isLoading } = useUserPassport();

  if (isLoading) return <Spinner />;

  return <>{children}</>;
};

export default UserPassport;
